import { buildApiUrl } from "../../../config.js";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Trash2 } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImageModal from "../../Sales Executive/Items Master/ImageModal";
import { FiShoppingBag } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";
import Select from "react-select";

const specialStyle = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "27px",
    height: "27px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "27px",
    padding: "0 4px",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "27px",
  }),
};

const style = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "28px",
    height: "28px",
    border: "none",
    boxShadow: state.isFocused ? "none" : "none",
    "&:hover": {
      border: "none",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "28px",
    padding: "0 4px",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "28px",
  }),
};

const PurchaseOrderForm = () => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [categories, setCategories] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [items, setItems] = useState([
    {
      Category: "",
      itemCode: "",
      itemDescription: "",
      unit: "",
      itemImage: "",
      Qtyctn: "0",
      Wtctn: "0",
      Cbmctn: "0",
      orderContainer: "0",
    },
  ]);
  const [referenceNo, setReferenceNo] = useState("");
  const [toPerson, setToPerson] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const [categoriesRes, suppliersRes, referenceRes] = await Promise.all([
          axios.get(
            buildApiUrl("/api/categories/all-categories"),
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          axios.get(
            buildApiUrl("/api/supplier/suppliers"),
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          axios.get(
            buildApiUrl("/api/purchase-order/last-reference"),
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
        ]);

        setCategories(categoriesRes.data.categories);
        setSuppliers(suppliersRes.data.suppliers);
        setReferenceNo(referenceRes.data.referenceNo);
      } catch (error) {
        console.error("Error fetching data", error);
        toast.error("Error fetching data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const resetForm = () => {
    setItems([
      {
        Category: "",
        itemCode: "",
        itemDescription: "",
        unit: "",
        itemImage: "",
        Qtyctn: "",
        Wtctn: "",
        Cbmctn: "",
        orderContainer: "",
      },
    ]);
    setToPerson("");
    // Fetch new reference number after reset
    const token = localStorage.getItem("token");
    axios
      .get(
        buildApiUrl("/api/purchase-order/last-reference"),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => setReferenceNo(response.data.referenceNo))
      .catch((error) => {
        console.error("Error fetching new reference number", error);
        toast.error("Error fetching new reference number");
      });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const formData = {
      referenceNo,
      toPerson,
      items,
    };

    try {
      const response = await axios.post(
        buildApiUrl("/api/purchase-order/purchase-order"),
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(response.data.message);
      resetForm();
    } catch (error) {
      console.error(error);
      toast.error("Error creating purchase order");
    } finally {
      setIsLoading(false);
    }
  };

  const addItem = () => {
    setItems([
      ...items,
      {
        Category: "",
        itemCode: "",
        itemDescription: "",
        unit: "",
        itemImage: "",
        Qtyctn: 0,
        Wtctn: 0,
        Cbmctn: 0,
        orderContainer: 0,
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const handleCategoryChange = (option, index) => {
    const newItems = [...items];
    const value = option ? option.value : "";
    newItems[index].Category = value;
    newItems[index].itemCode = "";
    newItems[index].itemDescription = "";
    newItems[index].unit = "";
    newItems[index].itemImage = "";
    newItems[index].Qtyctn = 0;
    newItems[index].Wtctn = 0;
    newItems[index].Cbmctn = 0;
    newItems[index].orderContainer = 0;
    setItems(newItems);
  };

  const handleItemChange = (option, index) => {
    const newItems = [...items];
    const value = option ? option.value : "";
    const selectedCategory = categories.find(
      (cat) => cat.categoryName === newItems[index].Category
    );
    const selectedItem = selectedCategory?.items.find(
      (item) => item.itemCode === value
    );

    if (selectedItem) {
      newItems[index] = {
        ...newItems[index],
        itemCode: selectedItem.itemCode,
        itemDescription: selectedItem.itemName,
        unit: selectedItem.unit,
        itemImage: selectedItem.itemImage,
        Qtyctn: selectedItem.pcsPerCtn || 0,
        Wtctn: selectedItem.wtPerCtn || 0,
        Cbmctn: selectedItem.cbmPerCtn || 0,
      };
    }

    setItems(newItems);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
    setSelectedImage("");
  };

  const supplierOptions = suppliers.map((supplier) => ({
    value: supplier.supplierName,
    label: supplier.supplierName,
  }));

  const categoryOptions = categories.map((category) => ({
    value: category.categoryName,
    label: category.categoryName,
  }));

  const getItemOptions = (categoryName) => {
    const selectedCategory = categories.find(
      (cat) => cat.categoryName === categoryName
    );
    return selectedCategory
      ? selectedCategory.items.map((item) => ({
          value: item.itemCode,
          label: item.itemName,
        }))
      : [];
  };

  return (
    <div className="">
      <div className="">
        <h1 className="text-md mb-2 sm:text-lg text-gray-600 font-semibold flex items-center gap-2">
          <FiShoppingBag />
          Create P. O.
        </h1>

        <div className="">
          <form onSubmit={onSubmit} className="space-y-4">
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
              <div className="flex items-center gap-2">
                <span className="font-medium text-red-600 text-sm">
                  Ref. No: <span className="text-red-600">*</span>
                </span>
                <input
                  type="text"
                  value={referenceNo}
                  readOnly
                  required
                  className="border bg-gray-50 border-gray-300 text-gray-700 outline-none rounded w-fit p-1 text-xs font-medium uppercase"
                />
              </div>
              <div className="flex items-center gap-2">
                <span className="font-medium text-red-600 text-sm">
                  To Supplier: <span className="text-red-600">*</span>
                </span>
                <Select
                  options={supplierOptions}
                  value={
                    toPerson
                      ? supplierOptions.find((opt) => opt.value === toPerson)
                      : null
                  }
                  onChange={(option) => setToPerson(option ? option.value : "")}
                  placeholder="Select Supplier"
                  isClearable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={specialStyle}
                  className="w-auto"
                  required
                />
              </div>
            </div>

            <div
              className="overflow-x-auto max-w-[100vw] rounded-lg max-h-[40rem] border border-gray-300"
              style={{ scrollbarWidth: "thin" }}
            >
              <table className="min-w-full table-auto rounded-lg shadow-md border-spacing-0 border-collapse">
                <thead className="top-0 z-50 sticky">
                  <tr className="bg-gray-700 text-white text-sm">
                    <th className="px-2 py-1 ">#</th>
                    <th className="min-w-24 sm:w-[25%] px-2 py-1 text-left font-normal tracking-wide">
                      Item Category *
                    </th>
                    <th className="min-w-24 sm:w-[25%] px-2 py-1 text-left font-normal tracking-wide">
                      Description *
                    </th>
                    <th className="min-w-24 sm:w-[10%] px-2 py-1 text-left font-normal tracking-wide">
                      Code
                    </th>
                    <th className="min-w-24 sm:w-[10%] px-2 py-1 text-left font-normal tracking-wide">
                      Image
                    </th>
                    <th className="min-w-16 sm:w-[5%] px-2 py-1 text-left font-normal tracking-wide">
                      Unit
                    </th>
                    <th className="min-w-16 sm:w-[5%] px-2 py-1 text-center font-normal tracking-wide">
                      QTY/CTN
                    </th>
                    <th className="min-w-16 sm:w-[5%] px-2 py-1 text-center font-normal tracking-wide">
                      WT/CTN
                    </th>
                    <th className="min-w-16 sm:w-[5%] px-2 py-1 text-center font-normal tracking-wide">
                      CBM/CTN
                    </th>
                    <th
                      className="min-w-16 sm:w-[10%] px-2 py-1 text-center font-normal tracking-wide"
                      title="Order-QTY/CTN"
                    >
                      O.Qty/CTN *
                    </th>
                    <th className="min-w-16 sm:w-[5%] px-2 py-1 text-center font-normal tracking-wide">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-50 border-b divide-x transition-colors"
                    >
                      <td className="px-2 text-gray-600">{index + 1}</td>
                      <td className="px-2">
                        <Select
                          options={categoryOptions}
                          value={
                            item.Category
                              ? categoryOptions.find(
                                  (opt) => opt.value === item.Category
                                )
                              : null
                          }
                          onChange={(option) =>
                            handleCategoryChange(option, index)
                          }
                          placeholder="Select Category"
                          isClearable
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={style}
                          className="w-full"
                          required
                        />
                      </td>
                      <td className="px-2">
                        <Select
                          options={getItemOptions(item.Category)}
                          value={
                            item.itemCode
                              ? getItemOptions(item.Category).find(
                                  (opt) => opt.value === item.itemCode
                                )
                              : null
                          }
                          onChange={(option) => handleItemChange(option, index)}
                          placeholder="Select Item"
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={style}
                          className="w-full"
                          required
                        />
                      </td>
                      <td className="bg-gray-100">
                        <input
                          type="text"
                          value={item.itemCode}
                          readOnly
                          className="bg-gray-100 text-gray-500 w-full px-2 py-1 text-md outline-none"
                        />
                      </td>
                      <td className="px-2">
                        {item.itemImage ? (
                          <img
                            src={item.itemImage}
                            alt="item_image"
                            className="size-4 rounded-md cursor-pointer transition-transform hover:scale-105"
                            onClick={() => handleImageClick(item.itemImage)}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="bg-gray-100">
                        <input
                          type="text"
                          value={item.unit}
                          readOnly
                          className="bg-gray-100 text-gray-500 w-full px-2 py-1 text-md outline-none"
                        />
                      </td>
                      <td className="bg-gray-100">
                        <input
                          type="number"
                          value={item.Qtyctn}
                          readOnly
                          className="bg-gray-100 text-gray-500 w-full px-2 py-1 text-md outline-none"
                        />
                      </td>
                      <td className="bg-gray-100">
                        <input
                          type="number"
                          value={item.Wtctn}
                          readOnly
                          className="bg-gray-100 text-gray-500 w-full px-2 py-1 text-md outline-none"
                        />
                      </td>
                      <td className="bg-gray-100">
                        <input
                          type="number"
                          value={item.Cbmctn}
                          readOnly
                          className="bg-gray-100 text-gray-500 w-full px-2 py-1 text-md outline-none"
                        />
                      </td>
                      <td className="px-2">
                        <input
                          type="number"
                          value={item.orderContainer}
                          onChange={(e) => {
                            const newItems = [...items];
                            newItems[index].orderContainer = Number(
                              e.target.value
                            );
                            setItems(newItems);
                          }}
                          required
                          className="w-full px-2 py-1 text-md text-gray-700 outline-none"
                        />
                      </td>
                      <td className="px-2 text-center">
                        <button
                          type="button"
                          onClick={() => handleDeleteRow(index)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <HiOutlineTrash size={14} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex gap-2 justify-end w-full">
              <button
                onClick={addItem}
                type="button"
                className="px-3 py-2 text-xs font-medium bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-gray-500 flex items-center gap-1"
                disabled={isLoading}
              >
                <FaPlus />
                Add Item
              </button>
              <button
                type="submit"
                className={`px-3 py-2 text-xs font-medium text-white rounded transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-red-800 flex items-center gap-1 ${
                  isLoading
                    ? "bg-red-400 cursor-not-allowed"
                    : "bg-red-700 hover:bg-red-900"
                }`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <svg
                      className="animate-spin h-4 w-4 mr-2 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      {isImageModalOpen && (
        <ImageModal imageUrl={selectedImage} onClose={closeImageModal} />
      )}
      <ToastContainer />
    </div>
  );
};

export default PurchaseOrderForm;
